import { ParserError } from './errors.js';
/** PRD §8.5 input limits. */
export const MAX_FILE_BYTES = 50 * 1024 * 1024;
export const MAX_WORDS = 2_000_000;
/** Byte gate — run against the raw input before any parsing work. */
export function assertByteLimit(byteLength) {
    if (byteLength > MAX_FILE_BYTES)
        throw new ParserError('file-too-large');
}
function countWords(text) {
    let count = 0;
    let inWord = false;
    for (let i = 0; i < text.length; i++) {
        const ws = isWhitespace(text.charCodeAt(i));
        if (!ws && !inWord)
            count++;
        inWord = !ws;
    }
    return count;
}
function isWhitespace(code) {
    return code === 0x20 || (code >= 0x09 && code <= 0x0d) || code === 0xa0;
}
/**
 * Shared tail of every parser: drop empty blocks, enforce the word limit,
 * reject empty results. Blocks must already be NFC-normalized.
 */
export function finalizeDocument(blocks) {
    const kept = blocks.filter((block) => block.text.length > 0);
    let wordCount = 0;
    for (const block of kept)
        wordCount += countWords(block.text);
    if (wordCount === 0)
        throw new ParserError('empty-document');
    if (wordCount > MAX_WORDS)
        throw new ParserError('too-many-words');
    return { blocks: kept, wordCount };
}
//# sourceMappingURL=limits.js.map